/**
 * @generated SignedSource<<1fe449ebf52cc05a95e4e2cf0503484f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BudgetData_project$data = {
  readonly id: string;
  readonly billable: boolean | null;
  readonly budgetType: BUDGET_TYPE | null;
  readonly " $fragmentSpreads": FragmentRefs<"Chart_project" | "HighLevelBudgetNumbers_project" | "Totals_project" | "InvoiceChart_project" | "RevenueRecognition_project">;
  readonly " $fragmentType": "BudgetData_project";
};
export type BudgetData_project$key = {
  readonly " $data"?: BudgetData_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetData_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetData_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Chart_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "currentMonthLastDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "currentYear",
          "variableName": "currentYear"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HighLevelBudgetNumbers_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Totals_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceChart_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RevenueRecognition_project"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "d0c357d955ed7dfd0e543694ff3774ea";

export default node;
